import { currentUser } from "@/core/users/session";
// Static table fields (before objectives)
export const TABLE_FIELDS = [
    "id",
    "region_de_ventas",
    "delegacion_zona_de_ventas",
    "sala",
    "distribuidor",
    "ano_natural",
    "mes_natural",
    "updated_at",
];
// Filter fields
const southFilterFields = ["region_de_ventas", "delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "sala", "distribuidor"];
const defaultFilterFields = ["region_de_ventas", "delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "sala", "distribuidor"];
export function getFilterFields() {
    const user = currentUser();
    const isSouthUser = user.area_code === "S" || user.region_code === "S300";
    return isSouthUser ? southFilterFields : defaultFilterFields;
}
// Sortable fields (static + objective fields)
export const SORTABLE_FIELDS = [
    // Static fields
    "id",
    "region_de_ventas",
    "delegacion_zona_de_ventas",
    "distribuidor",
    "area_de_ventas",
    "delegacion",
    "zona_de_ventas",
    "ano_natural",
    "mes_natural",
    "sala",
    "updated_at",
];
// Default sort configuration
export const DEFAULT_SORTS = [{ field: "region_de_ventas", direction: "asc" }];
// Preset sort configurations
export const PRESET_SORTS = [
    {
        label: "Por Delegación A-Z",
        sorts: [{ field: "delegacion_zona_de_ventas", direction: "asc" }],
    },
    {
        label: "Por Región + Delegación",
        sorts: [
            { field: "region_de_ventas", direction: "asc" },
            { field: "delegacion_zona_de_ventas", direction: "asc" },
        ],
    },
    {
        label: "Por Sala",
        sorts: [{ field: "sala", direction: "asc" }],
    },
];
